import pixAxios from '@/axios/pixAxios.js';
import Console from '@/shared/console';

const reportModule = {
  namespaced: true,

  state: {
    reportEngineUrl: null,
  },

  actions: {
    async loadReportEngineUrl({ state, commit }) {
      if (state.reportEngineUrl) {
        return;
      }
      try {
        const {
          data: { reportEngineUrl },
        } = await pixAxios.get('api/KeyVault/GetReportEngineUrl');
        if (reportEngineUrl) {
          commit('setReportEngineUrlKey', reportEngineUrl);
        } else {
          Console.error('Could not retrieve Property Report Engine Url key from keyvault');
        }
      } catch (error) {
        Console.error('Could not retrieve Property Report Engine Url key from keyvault');
      }
    },
  },

  mutations: {
    setReportEngineUrlKey(state, payload) {
      state.reportEngineUrl = payload;
    },
  },
};

export default reportModule;
